import config from '../../../configuration/configuration.js';
import AxiosRequest from '../../../utils/AxiosRequest';

export const MopRanReportUploadRequest = (filePath, userId) => AxiosRequest({
	method: 'POST',
	url: `${config.API_URL}ServiceDesk/GenerateCRQ`,
	params: { filePath, userId }
});

export const GetTemplateRequest = (userId) => AxiosRequest({
	method: 'GET',
	url: `${config.API_URL}ServiceDesk/GetMopRanTemplate`,
	params: { userId }
});
